<template>
   <div v-if="!ishavedata" class="d-flex justify-center align-center">
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </div>
    <div class="mt-5" v-else>
      <app-widget
        title="Applied seasonality & decay rates of activities"
        headingicon="false"
        helpicon="true"
        imgname="table data-sheet.png"
        titleicon="mdi-grid"
        helpheading="Data - Applied Seasonality & Decay Rates of Activities"
        no-padding
      >
        <div slot="help-content">
          Data - Applied Seasonality & Decay Rates of Activities
        </div>
  
        <div slot="widget-content">
          <div class="mt-2">
            <v-simple-table fixed-header height="500px">
              <thead>
                <tr>
                  <th
                    v-for="(element, key) in itemlist[0]"
                    :key="element.variable"
                    class="text-center"
                    style="background: #f1f1f1"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span class="titleText--text font-weight-bold" v-bind="attrs" v-on="on">
                          <span>
                            {{ key | tableheader }}
                            <span v-if="key === 'Sales_Value'"> ({{currency}}) </span>
                          </span>
                        </span>
                      </template>
                      <span>{{ fullName(key) }}</span>
                    </v-tooltip>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item) in itemlist" :key="item">
                  <td v-for="(element, index) in item" :key="index" :class="['region', 'date'].includes(index) ? 'text-center' : 'text-right'">
                    <div :style="{width: index === 'date' ? '100px' : ''}">
                      <span v-if="fullNameIsExist(index)" class="titleText--text">
                      {{ fullName(index) === 'sales_value' ? currencyNumberFormat(element) : element}}
                      </span>
                      <span v-else-if="index === 'date'" class="titleText--text">{{ formattedDate(element) }}</span>
                    <span v-else class="titleText--text">{{ fullName(index) === 'sales_value' ? currencyNumberFormat(element) : numberFormat(element)}}</span>
                  </div>
                    
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </div>
      </app-widget>
    </div>
</template>
<script>
import apifactory from "../api";
import AppWidget from "../../../components/AppWidget.vue";
import moment from 'moment'

export default {
  components: {
    AppWidget,
  },
  props: {
    options: {
      type: [],
      required: true,
    },
    title: {
      type: String,
      required: true,
    }
  },
  data: () => ({
    itemlist: [],
    strnodatafount: "No Data Found",
    ishavedata: false,
    level: "",
    levelSubNation: "subnational",
    issubnation: false,
    columndesc: [],
    dataregionSelected: null,
    apidata: [],
  }),
  methods: {
    fullNameIsExist (item) {
      let outresult=false;
      if(item == 'region'){outresult= true;}
      return outresult;
    },
    currencyNumberFormat (number) {
      const formatter = new Intl.NumberFormat('en-CA', {
        style: 'currency',
        maximumFractionDigits: 0,
        currency: this.currency || 'usd'
      })

      return formatter.format(number);
    },
    numberFormat (number) {
      const formatter = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 0,
      })

      return formatter.format(number)
    },
    formattedDate (date) {
      return moment(date).format("DD.MM.YYYY")
    },
    refresh(vardataregionSelected) {
      this.dataregionSelected = vardataregionSelected;
      this.loadData();
    },
    loadDataAfterSave() {
      apifactory
        .call_get_step5_output()
        .then((res) => {
          if (res.status != 200) {
            alert("Sorry");
          } else {
            
            this.apidata = res.data.data;
            this.columndesc = res.data.column_description;
            this.level = res.data.project_level;
            if (this.level == "subnational") {
              this.isdatasublevel = true;
              this.itemlist = res.data.data.filter(
                (a) => a.region == this.dataregionSelected
              );
            } else {
              this.isdatasublevel = false;
              this.itemlist = res.data.data;
            }
            this.ishavedata = true;
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
    loadData() {
      apifactory
        .call_save_step5()
        .then((res) => {
          this.loadDataAfterSave();
        })
        .catch(function (error) {
          alert(error);
        });
    },
  },
  computed: {
    fullName() {
      return (theParam) => {
        let desc = [];
        desc = this.columndesc.filter((a) => a.column == theParam);
        return desc[0].description;
      };
    },
    isdatasublevel() {
      if (this.level === this.levelSubNation) {
        return true;
      } else {
        return false;
      }
    },
    currency () {
      return localStorage.getItem('currency')
    }
  },
  mounted() {
    this.refresh(this.title);
  },
};
</script>
<style>
.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:not(.v-data-table__mobile-row) {
  border-bottom: 1px solid #f1f1f1
}
</style>